// src/layouts/AppLayout.jsx
import React from 'react';
import TopPageHeader from '../ui/PageHeader';
import './AppLayout.css';

/**
 * AppLayout — Layout principal para páginas internas (logado).
 * Substitui o PageLayout antigo com o Design System oficial.
 *
 * @param {string} title       - Título da página (gradiente)
 * @param {string} subtitle    - Subtítulo da página
 * @param {node}   actions     - Botões de ação no header
 * @param {node}   children    - Conteúdo principal
 * @param {node}   sidebar     - Conteúdo lateral (opcional)
 * @param {boolean} fullWidth  - Sem sidebar, conteúdo full width
 * @param {node}   header      - Header customizado (substitui TopPageHeader)
 */
export default function AppLayout({
  title,
  subtitle,
  actions,
  children,
  sidebar,
  fullWidth = false,
  header,
  className = '',
}) {
  return (
    <div className={`app-layout ${className}`}>
      {header || <TopPageHeader />}

      <div className="app-layout__shell">
        {(title || subtitle || actions) && (
          <header className="app-layout__heading mp-anim-fade-in">
            <div className="app-layout__heading-text">
              {title && <h1 className="app-layout__title">{title}</h1>}
              {subtitle && <p className="app-layout__subtitle">{subtitle}</p>}
            </div>
            {actions && <div className="app-layout__actions">{actions}</div>}
          </header>
        )}

        <div className={`app-layout__body ${fullWidth || !sidebar ? 'app-layout__body--full' : ''}`}>
          <div className="app-layout__primary mp-anim-fade-in">
            {children}
          </div>
          {sidebar && !fullWidth && (
            <aside className="app-layout__secondary mp-anim-fade-in">
              {sidebar}
            </aside>
          )}
        </div>
      </div>
    </div>
  );
}
